import ICategory from "../../../models/ICategory";
import ITypeaheadCatalogItemDTO from "../../../models/DTO/ITypeaheadCatalogItemDTO";

export default class EcommerceViewService {
    /**
     * Resolves the category scoping fields for a typeahead request. Root categories are sent as
     * categoryId; a guid not found in rootCategories is a subcategory (e.g. URL-driven search),
     * which is sent as categoryGuid for the backend to resolve.
     */
    static getTypeaheadCategoryScope(
        _categoryGuid: string | undefined,
        _categoryId: number | undefined,
        rootCategories: ICategory[],
        contextCategory: ICategory | undefined
    ): Partial<ITypeaheadCatalogItemDTO> {
        if (!_categoryGuid && !contextCategory && _categoryId === undefined) {
            return {};
        }

        const scope: Partial<ITypeaheadCatalogItemDTO> = { includeSubcategories: true };

        // If we have a category ID directly, use it (0 is a valid virtual-category sentinel id)
        if (_categoryId !== undefined) {
            scope.categoryId = _categoryId;
        } else {
            const categoryModel = rootCategories.find((cat) => cat.guid === _categoryGuid);

            if (categoryModel) {
                scope.categoryId = categoryModel.id;
            } else if (_categoryGuid) {
                scope.categoryGuid = _categoryGuid;
            }

            // Only check the context category if no _categoryGuid was provided
            if (!_categoryGuid && contextCategory) {
                scope.categoryId = contextCategory.id;
            }
        }

        return scope;
    }
}
